export default "__VITE_ASSET__uTqL5U90__"